export default {"src":"/_next/static/media/wallet-avalanche.88e58af8.svg","height":64,"width":64};